import * as React from "react";
import { cn } from "../../lib/utils";

const Label = React.forwardRef(({ className, style, ...props }, ref) => (
  <label
    ref={ref}
    className={cn("tw-text-sm tw-font-medium tw-leading-none tw-text-white", className)}
    style={{
      display: "block",
      marginBottom: 8,
      fontSize: 13,
      fontWeight: 600,
      lineHeight: 1.3,
      color: "#c3c8cc",
      ...style,
    }}
    {...props}
  />
));
Label.displayName = "Label";

export { Label };
